module.exports = __webpack_public_path__ + "assets/images/coin-10-print.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-10-print.png
// module id = 140
// module chunks = 1